export interface AnglerViewOptions {
  id: string;
  label: string;
  value: 'catches' | 'posts';
}

export const ANGLER_VIEW_OPTIONS: AnglerViewOptions[] = [
  { id: 'catches', label: 'Catches', value: 'catches' },
  { id: 'posts', label: 'Posts', value: 'posts' },
];
